import { dispatchContinueWithSSOButtonClickedEvent } from '../../avro';
import { urls } from '@zapier/identity-utils';
import { addParamsToUrl } from '@zapier/url-utils';
import { SocialAuthButton } from '../global/SocialAuthButton';
import { SSOIcon } from '../global/SSOIcon';
import { QueryParams, RouteTo } from '../../types';
import { defaultRouteTo } from '../../utils';
import { MouseEvent } from 'react';

type Props = {
  /** Routing callback to integrate with router. Will use window.href.location directly when not specified */
  routeTo?: RouteTo;

  /**
   * Query params to pass to the login with identity provider page. This will generally be all of them, since it's
   * just login but with a different mechanism.
   */
  queryParams?: QueryParams;
};

export function ContinueWithSSOButton({
  routeTo = defaultRouteTo,
  queryParams,
}: Props) {
  const redirectUrl = addParamsToUrl(urls.LOGIN_WITH_SSO_URL, queryParams);

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    dispatchContinueWithSSOButtonClickedEvent();
    routeTo(redirectUrl);
  };

  return (
    <SocialAuthButton
      href={redirectUrl}
      icon={<SSOIcon />}
      onClick={handleClick}
    >
      Continue with SSO
    </SocialAuthButton>
  );
}
